import React from 'react'
import SmallSection from '../../../../../../Components/SmallSection'

const OnSiteTrainingSection = ({ data }) => {
  const { comment, date, rated_by, rating, user_who_rated_id } = data

  const LinkUserThatRated = () => (
    <a
      href={`/dashboard/users/${user_who_rated_id}`}
      target="_blank"
      rel="noreferrer"
    >
      {rated_by}
    </a>
  )

  const userInfo = [rating, date, LinkUserThatRated, comment || '-']

  const columns = [
    {
      id: 1,
      columnName: 'Rating',
    },
    {
      id: 2,
      columnName: 'Date',
    },
    {
      id: 3,
      columnName: 'Rated by',
    },
    {
      id: 4,
      columnName: 'Comment',
    },
  ]

  return (
    <SmallSection title="Onsite training" columns={columns} data={userInfo} />
  )
}

export default OnSiteTrainingSection
